// extracted by mini-css-extract-plugin
module.exports = {"active":"OfferStatusTag_active__27L-W","draft":"OfferStatusTag_draft__3PS7m"};